module.exports = __webpack_public_path__ + "img/big_1_68.8dabdf8a.png";